import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueHeadful from 'vue-headful'
import axios from 'axios'
import './polyfills.js'

// CSS - TODO: Distribute into the Single File Components
import './wdig.scss' 

Vue.config.productionTip = false

Vue.component('vue-headful', vueHeadful);

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

window.appWDIG = new Vue({
	router,
	components: { App },
	template: '<App :nav="nav" :items="items" :aliases="uniqueAliases" :rates="rates" />',
	data() {
		return {
			igxItems: [],
			items: [],
			aliases: [],
			rates: [],
			nav: [],
			urls: {
				rates: 'https://data.seattle.gov/resource/j6qn-qavz.json',
				api: '',
			}
		}
	},
	computed: {
		uniqueAliases() {
			return this.aliases.filter((obj, pos, arr) => {
				return arr.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
			});
		}
	},
	created: function() {
		this.getAPI()
		this.getNav()
		this.getRates()
	},
	mounted: function() {
		this.sortByProp(this.items, 'name');
	},
	methods: {  
		getAPI: function() {
			let location = window.location.href,
				api = '/api/content/';

			if (location.indexOf('localhost') > 0) {
				api = '/api/content/'
			}
			
			this.urls.api = api

			return api
		},
		getNav: function() {
			// local = 2803
			return axios.get(`${ this.urls.api }taxonomy/3087/tree`)
				.then(res => {
					let taxonomy = res.data

					// console.log('Taxonomy', taxonomy)

					// this.nav = taxonomy

					return taxonomy
				}).then(this.getIGXcomponents)
		},
		getIGXcomponents: function(nav) {
			// local = 2797
			// axios.get(`${ this.urls.api }x112286/condensed`)
			axios.get(`${ this.urls.api }taxonomy/3086/pages`)
			.then(res => {

				let components = [...res.data]
				let items = []
				let categoryItems = {}
				
				// Transform IGX JSON to Old Socrata Format (it's cleaner)
				// console.log('IGX Raw Objects:', components)

				for (const component of components) {

					let item = {
						id 	: component.Id,
						content : {}
					}

					for (const prop in component) {
						let value = component[prop]

						switch (prop) {
							case 'Name':
								item.name = value
								break

							case 'Alias':
								item.aliases = value
								break

							case 'Taxonomies':
								item.categories = value.split('|')
								break

							default:
								if (value !== '') item.content[prop] = value
								break
						}
					}
					
					// Assign items to categories
					item.categories.forEach(cat => {
						// console.log(category)
						if (typeof(categoryItems[cat]) == 'undefined') categoryItems[cat] = []
						
						categoryItems[cat].push({
							name: item.name,
							id: item.id
						})
					})


					// Assign items to categories
					// for (const id of item.categories) {
					// 	let category = navList.find(x => x.id == id)

					// 	if (category) category.children.push({ 'name':item.name, 'id':item.id })
					// }

					items.push(item)
				}


				// console.log(items)
				// console.log(categoryItems)

				this.setNav(nav, categoryItems)

				return items
			})
			.then(this.setItems)
		},
		convertNavListToTree(navList) {
			let navTree = [navList.shift()]

			/* Recursively add to tree */
			function addToTree(parent, ancestors, item) {

				if (ancestors.length == 2) {
					parent.children.push(item)
				} else {
					ancestors.shift()

					let next = parent.children.find(x => x.name == ancestors[0])

					addToTree(next, ancestors, item)
				}
			}

			/* Loop through all nav items */
			navList.forEach(item => {
				let ancestors = item.path.split('>')

				delete item.path

				addToTree(navTree[0], ancestors, item)
			});

			// console.log('Nav List: ', navList)
			// console.log('Nav Tree: ', navTree)

			this.nav = navTree[0].children
		},
		setNav(nav, items) {
			// console.log('Nav', nav)
			// console.log('Category/Item Associations', items)

			const traverseNav = function(nav) {
				for (let category of nav) {
					// console.log(category)

					if (category.children) traverseNav(category.children)


					let categoryItems = items[category.id]

					if (categoryItems) {
						category.children = (category.children) ? [...category.children, ...categoryItems] : categoryItems
			
						// console.log(category.children)
					}
					
				}
			}
			traverseNav(nav)


			this.nav = nav
		},
		setItems: function(items) {
			this.items = items;

			// console.log('setting items')
			this.sortByProp(this.items, 'name');
			this.getAliases(this.items);
			// this.sortByProp(this.aliases, 'name');
		},
		getAliases: function(items) {

			// console.log('aliases start')
			let appAliases = [];

			items.forEach(function(i) {
				let name = i.name,
					id = i.id,
					aliases = i.aliases;
		
				if (name) appAliases.push({'name': name.toLowerCase(), 'id': id});
				
				if (aliases) {	
					for (const alias of aliases) {
						appAliases.push({'name': alias.toLowerCase(), 'id': id});
					}
				}
			})

			this.aliases = appAliases
		},
		getRates: function() {
			let self = this;
			axios.get(self.urls.rates)
			.then(function(res) {
				self.rates = res.data;
			})
			.catch(function() {
				axios.get(self.urls.ratesBKUP)
				.then(function(res) {
					self.rates = res.data;
				})
			})
		},
		sortByProp: function(items, x = 'name') {
			items.sort(function(a, b) {
				var textA = a[x].toLowerCase();
				var textB = b[x].toLowerCase();
				return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
		}
	}
}).$mount('#app-wdig')

